import React from 'react';
import './LoyaltyBenefits.css';
import BestRateGuaranteedIcon from "assets/img/BestRateGuaranteedIcon.png";
import CoinsDurationIcon from "assets/img/CoinsDurationIcon.png";
import EarnCoinsIcon from "assets/img/EarnCoinsIcon.png";
import RedeemCoinsIcon from "assets/img/RedeemCoinsIcon.png";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getLoy3Profile } from "../../selectors/authentication";

class LoyaltyBenefits extends React.Component {
  render() {
    const { loy3Profile } = this.props;

    return (
      <div className="benefits-container">
        <div className="benefits-header">
          <h2>{this.context.t('YOUR BENEFITS')}</h2>
          <p className="membership-level">Sandos4u {loy3Profile && loy3Profile.memberShipName}</p>
        </div>

        <div className="benefits-list">
          <div className="benefit-item">
            <div className="benefit-icon">
              <img src={BestRateGuaranteedIcon} alt="Icono beneficio" className="benefit-image" />
            </div>
            <div className="benefit-content">
              <h3>{this.context.t('BEST RATE GUARANTEED')}</h3>
              <p>{this.context.t('Unlock the best exclusive member rate')}.</p>
            </div>
          </div>

          <div className="benefit-item">
            <div className="benefit-icon">
              <img src={EarnCoinsIcon} alt="Icono beneficio" className="benefit-image" />
            </div>
            <div className="benefit-content">
              <h3>{this.context.t('EARN COINS')}</h3>
              <p>{this.context.t('Earn coins with every stay')}.</p>
            </div>
          </div>

          <div className="benefit-item">
            <div className="benefit-icon">
              <img src={RedeemCoinsIcon} alt="Icono beneficio" className="benefit-image" />
            </div>
            <div className="benefit-content">
              <h3>{this.context.t('REDEEM COINS')}</h3>
              <p>{this.context.t('Redeem your coins for amazing rewards')}.</p>
            </div>
          </div>

          {/* <div className="benefit-item">
            <div className="benefit-icon">
              <img src={CoinsDurationIcon} alt="Icono beneficio" className="benefit-image" />
            </div>
            <div className="benefit-content">
              <h3>TUS COINS DURAN MÁS</h3>
              <p>Expiración de Coins en 4 años</p>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

LoyaltyBenefits.propTypes = {
  loy3Profile: PropTypes.object,
};

LoyaltyBenefits.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loy3Profile: getLoy3Profile(state),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyBenefits);
